// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VersionBadge_wrapper__3erxN","version":"VersionBadge_version__2bdPX","pending":"VersionBadge_pending__3SGgB","compact":"VersionBadge_compact__3QBbF"};